module.exports = __webpack_public_path__ + "static/media/todos-call.14fbd85a.svg";